<template>
    <div style="background:white; height:100%">
        <div class="headbar">
            <span style="font-size:12px; font-weight:600;margin-left:5px;margin-right:3px">国家</span>
            <el-select multiple v-model="areano" clearable @change="areaChg"  placeholder="请选择" size="small" style="width:260px; height:35px;">
                <span v-for="item in counArr" :key='item.key'>
                    <el-option :label="item.SUBNM" :value="item.SUBNO" style="width:170px;"></el-option>
                </span>
            </el-select>
            <span style="font-size:12px; clearable font-weight:600;margin-left:5px;margin-right:3px">店铺名称</span>
            <el-select multiple v-model="shopid"  placeholder="请选择店铺" size="small" style="width:390px;height:35px;">
                <span v-for="item in shopArr" :key='item.key'>
                    <el-option :label="item.CNAME" :value="item.CODE" style="width:200px;"></el-option>
                </span>
            </el-select>
            <span style="font-size:12px;  font-weight:600;margin-left:20px;margin-right:3px">交易日期</span>
            <el-date-picker :editable="false" :clearable="false" type="date" size="small"  v-model="frdttm"  value-format="yyyy-MM-dd" style="width:135px" ></el-date-picker>  
            <span style="font-size:12px;  font-weight:600;margin-left:5px;margin-right:5px">-</span>
            <el-date-picker :editable="false" :clearable="false" type="date" size="small"  v-model="todttm"  value-format="yyyy-MM-dd" style="width:135px; " ></el-date-picker>  
 
            <el-button size="mini" type="primary" icon="iconfont icon-gaojichazhao2" @click="qryTabData" style="width:70px;height:35px;margin-left:10px; "><span style="margin-left:5px;font-size:12px">查询</span></el-button>    
        </div>
        <div style="line-height:25px;height:55px;background:white;width:100%">
            <div style="display:flex;width:1000px;">
                <div style="font-size:12px;font-weight:700;width:80px;">Summaries</div>
                <div style="font-weight:600;font-size:12px; ">Can include Amazon Marketplace,Fulfillment by Amazon(FBA),and Amazon Webstore transactions Account Types Included-Standard Orders,Invoiced Orders</div>
            </div>
            <div style="display:flex;width:1000px;">
                <div style="font-size:12px;font-weight:700;width:80px;">汇总</div>
                <div style="font-weight:600;font-size:12px;">可以包括亚马逊商城、亚马逊物流（FBA）和亚马逊网上商店交易 账户类型 - 标准订单、发票订单</div>
            </div>
        </div>
        <div style="background:white;width:100%;display:flex"> 
            <div>
                <div style="line-height:30px;height:30px;border:1px solid #409eef;width:840px">
                    <div style="display:flex">
                        <div style="width:140px;font-size:12px;">Income 收入</div>
                        <div style="width:530px;font-size:12px;">Net sales, credits, and refunds 净销售、赊欠及返还</div>
                        <div style="width:140px;font-size:12px;">合计∑  {{inSum}}</div>
                    </div>
                </div>
                <div style="line-height:25px;height:50px;background:white;border:1px solid #409eef;width:840px">
                    <div style="display:flex">
                        <div style="width:140px;font-size:12px;">Expenses 费用</div>
                        <div style="width:530px;font-size:12px;">Net fees,including Amazon service fees,selling fees,FBA fees,shipping,and taxes<br>净费用、包括服务费、销售费、FBA费用、运费及税</div>
                        <div style="width:140px;font-size:12px;">合计∑  {{exSum}}</div>
                    </div>
                </div>
                <div style="line-height:30px;height:30px;border:1px solid #409eef;width:840px">
                    <div style="display:flex">
                        <div style="width:140px;font-size:12px;">Tax 税</div>
                        <div style="width:530px;font-size:12px;">Net taxes Collected on product sales and services 净销售及服务税</div>
                        <div style="width:140px;font-size:12px;">合计∑  {{taxSum}}</div>
                    </div>
                </div>
                <div style="line-height:30px;height:30px;border:1px solid #409eef;width:840px">
                    <div style="display:flex">
                        <div style="width:140px;font-size:12px;">Transfers 付款</div>
                        <div style="width:530px;font-size:12px;">Net deposits and withdrawals 净存款及取款</div>
                        <div style="width:140px;font-size:12px;">合计∑  {{tranSum}}</div>
                    </div>
                </div>
            </div>
            <!-- 各项指标比例 -->
            <div style="line-height:25px;height:80; width:1100px;display:flex;margin-left:10px;">
                <div style="width:100px;border:1px solid #ccc">
                    <div style="display:flex;flex-direction:column">
                        <div style="line-height:25px;margin-top:20px;text-align:center;font-weight:700;font-size:14px;color:#409eef">{{inSum>0?(Math.abs(tranSum)/inSum*100).toFixed(1)+'%':'0.0%'}}</div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">回款比例</div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">(占总销售额)</div>
                    </div>
                </div>
                <div style="width:110px;border:1px solid #ccc;margin-left:10px">
                    <div style="display:flex;flex-direction:column">
                        <div style="line-height:25px;margin-top:20px;text-align:center;font-weight:700;font-size:14px;color:green">
                            {{v_saleQty>0?(v_rtnQty/v_saleQty*100).toFixed(1)+'%':'0.0%'}}
                        </div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">总体退货数量比例</div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">(数量)</div>
                    </div>
                </div>
                <div style="width:110px;border:1px solid #ccc;margin-left:10px">
                    <div style="display:flex;flex-direction:column">
                        <div style="line-height:25px;margin-top:20px;text-align:center;font-weight:700;font-size:14px;color:red">
                            {{inSum>0?(Math.abs(v_rtnAmt)/inSum*100).toFixed(1)+'%':'0.0%'}}
                        </div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">总体退货数量比例</div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">(金额)</div>
                    </div>
                </div>
                <div style="width:110px;border:1px solid #ccc;margin-left:10px">
                    <div style="display:flex;flex-direction:column">
                        <div style="line-height:25px;margin-top:20px;text-align:center;font-weight:700;font-size:14px;color:#003d79">
                            {{inSum>0?(Math.abs(v_adFee)/inSum*100).toFixed(1)+'%':'0.0%'}}
                        </div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">广告比例</div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">(占总销售额度)</div>
                    </div>
                </div>
                <div style="width:110px;border:1px solid #ccc;margin-left:10px">
                    <div style="display:flex;flex-direction:column">
                        <div style="line-height:25px;margin-top:20px;text-align:center;font-weight:700;font-size:14px;color:#484891">
                            {{inSum>0?(Math.abs(v_shpFee)/inSum*100).toFixed(1)+'%':'0.0%'}}
                        </div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">运费比例</div>
                        <div style="line-height:25px;text-align:center;font-size:12px;">(占总销售额度)</div>
                    </div>
                </div>
                <div style="width:110px;border:1px solid #ccc;margin-left:10px">
                    <div style="display:flex;flex-direction:column">
                        <div style="line-height:35px;margin-top:20px;text-align:center;font-weight:700;font-size:14px;color:#AD5A5A">
                            {{ '0.0%'}}
                        </div>
                        <div style="line-height:35px;text-align:center;font-size:12px;">毛利率</div>
 
                    </div>
                </div>
            </div>
        </div>
        <!-- 明细资料 -->
        <div :style="{'overflow-y':'auto','height':tabHeight,'margin-top':'4px'} ">           
            <div style="line-height:35px;height:35px;background:#FFcbb3;color:#409eef">
                <div style="display:flex;font-weight:600;font-size:12px;">
                    <div style="width:38%;padding-left:6px">Income</div>
                    <div style="width:12%">合计 {{inSum}}</div>
                    <div style="width:38%">Expenses</div>
                    <div style="width:12%">合计 {{exSum}}</div>
                </div>
            </div>
            <div style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;background:white">
                <div style="display:flex;font-weight:600;font-size:12px;">
                    <div style="width:38%;padding-left:6px">项目</div>
                    <div style="width:6%">Debits</div>
                    <div style="width:6%">Credits</div>
                    <div style="width:38%; ">项目</div>
                    <div style="width:6%">Debits</div>
                    <div style="width:6%">Credits</div>
                </div>
            </div>
            <div style=" background:white; ">
                <div style="display:flex;font-weight:600;font-size:12px;">
                    <!-- 收入 --> 
                    <div  style="width:38%">
                        <div v-for="(item,index) in inData" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  style=" padding-left:6px;width:100%;text-overflow:ellipsis;overflow:hidden; white-space:nowrap; ">{{item.ENAME}} - {{item.CNAME}}</div>     
                        </div>  
                    </div>
                    <div  style="width:12%">
                        <div v-for="(item,index) in tempData" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  :class="item.left=='Y'?'left':'right'">{{item.prc=='0.00'?'':item.prc}} </div>    
                        </div>
                    </div>
                     
                    <!-- 费用 -->
                    <div  style="width:38%">
                        <div v-for="(item,index) in exData" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  style=" padding-left:6px;width:80%;text-overflow:ellipsis;overflow:hidden; white-space:nowrap;">{{item.ENAME}} - {{item.CNAME}}</div>
                        </div>
                    </div>
                    <div  style="width:12%">
                        <div v-for="(item,index) in exArr" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  :class="item.left=='Y'?'left':'right'">{{item.prc=='0.00'?'':item.prc}} </div>    
                        </div>
                    </div>
                </div>
                <div style="width:100%;line-height:30px; border:1px solid #FFcbb3;"> 
                    <div style="display:flex">
                        <div style="width:38%;text-align:right;padding-right:20px;border-right:1px solid #FFcbb3;font-size:12px;">小计</div>
                        <div style="width:6%;padding-left:2px;font-size:12px;">{{v_inleft}} </div>
                        <div style="width:6%;text-align:right;padding-right:3px;font-size:12px;">{{v_inright}} </div>
                        <div style="width:38%;text-align:right;padding-right:20px;border-right:1px solid #FFcbb3;border-left:1px solid #FFcbb3;font-size:12px;">小计</div>
                        <div style="width:6%;padding-left:2px;font-size:12px;">{{v_exleft}} </div>
                        <div style="width:6%;text-align:right;padding-right:3px;font-size:12px;">{{v_exright}} </div>
                    </div>
                </div>
            </div>
            <div style="line-height:35px;height:35px;background:#FFcbb3;color:#409eef">
                <div style="display:flex;font-weight:600;font-size:12px;">
                    <div style="width:38%;padding-left:6px">Transfer</div>
                    <div style="width:12%">合计 {{tranSum}}</div>
                    <div style="width:38%">Tax</div>
                    <div style="width:12%">合计 {{taxSum}}</div>
                </div>
            </div>
            <div style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;background:white">
                <div style="display:flex;font-weight:600;font-size:12px;">
                    <div style="width:38%;padding-left:6px">项目</div>
                    <div style="width:6%">Debits</div>
                    <div style="width:6%">Credits</div>
                    <div style="width:38%; ">项目</div>
                    <div style="width:6%">Debits</div>
                    <div style="width:6%">Credits</div>
                </div>
            </div>
            <div style=" background:white; padding-bottom:10px; ">
                <div style="display:flex;font-weight:600;font-size:12px;">
                    <!-- 转账 -->
                    <div  style="width:38%">
                        <div v-for="(item,index) in trData" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  style=" padding-left:6px;width:80%;text-overflow:ellipsis;overflow:hidden; white-space:nowrap;">{{item.ENAME}} - {{item.CNAME}}</div>
                        </div>
                    </div>
                    <div  style="width:12%">
                        <div v-for="(item,index) in transArr" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  :class="item.left=='Y'?'left':'right'">{{item.prc=='0.00'?'':item.prc}} </div>    
                        </div>
                    </div>
                    <!-- 税费 -->
                    <div  style="width:38%">
                        <div v-for="(item,index) in taxData" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  style=" padding-left:6px;width:80%;text-overflow:ellipsis;overflow:hidden; white-space:nowrap;">{{item.ENAME}} - {{item.CNAME}}</div>
                        </div>
                    </div>
                    <div  style="width:12%">
                        <div v-for="(item,index) in taxArr" :key="index" style="line-height:35px;height:35px;border:1px solid #FFcbb3;color:#409eef;display:flex" >
                            <div  :class="item.left=='Y'?'left':'right'">{{item.prc=='0.00'?'':item.prc}} </div>    
                        </div>
                    </div>
                </div>
                <div style="width:100%;line-height:30px; border:1px solid #FFcbb3;"> 
                    <div style="display:flex">
                        <div style="width:38%;text-align:right;padding-right:20px;border-right:1px solid #FFcbb3;font-size:12px;">小计</div>
                        <div style="width:6%;padding-left:2px;font-size:12px;">{{v_trleft}} </div>
                        <div style="width:6%;text-align:right;padding-right:3px;font-size:12px;">{{v_trright}} </div>
                        <div style="width:38%;text-align:right;padding-right:20px;border-right:1px solid #FFcbb3;border-left:1px solid #FFcbb3;font-size:12px;">小计</div>
                        <div style="width:6%;padding-left:2px;font-size:12px;">{{v_taxleft}} </div>
                        <div style="width:6%;text-align:right;padding-right:3px;font-size:12px;">{{v_taxright}} </div>
                    </div>
                </div>
            </div>
            
        </div>
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate} from '../../api/Select'  
//局部注册
export default {
    name:"operate_Summary",
    data () {
        return {   
            qryData:[],
            frdttm:'',
            todttm:'',
            shopid:'', 
            loadWin:false,
            tempData:[],    
            inSum:'', //收入合计
            exSum:'', //费用合计
            tranSum:'',
            taxSum:'',
            promptWin:false,
            prompt:'',
            operArr:[],
            inData:[],
            exData:[],
            trData:[],
            taxData:[],
            tabArr:[], //表列   
            subData:[],  
            shopArr:[],  
            oper:'like',
            txtparam:'',
            selparam:'',  
            exArr:[] , //交易费用
            transArr:[],
            taxArr:[],
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_bsurl:'xuper_auth/getTableRecMany'  ,       
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            counArr:[],    
            areano:'',
            v_area:'',
            v_inleft:'',
            v_inright:'',
            v_exleft:'',
            v_exright:'',
            v_trleft:'',
            v_trright:'',
            v_taxleft:'',
            v_taxright:'',
            v_adFee:'',
            v_shpFee:'',
            v_saleQty:0, //经营数量
 
            v_rtnQty:0, //退货数量
            v_rtnAmt:0,
        }
    }, 
    mounted () { 
        //操作符
        getBaseData(this.v_bsurl,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //店铺
        getBaseData(this.v_bsurl,'PARENTNO','22363','','','v_sys_base','').then(res=>{
            let temp =res.result
            temp.forEach(item=>{
                let v_bool =true
                this.counArr.some(it=>{
                    if (it.SUBNO==item.SUBNO){
                        v_bool =false
                    }
                })
                if (v_bool){
                    this.counArr.push({SUBNO:item.SUBNO,SUBNM:item.SUBNO2})
                }
            })
        })
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 325) + 'px';
        }, 
    },
    components: {
     
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getSubList(' order by idno')
            this.getTabField() //表列字段
            this.frdttm =getDate('yr')+'-01-01'
            this.todttm=getDate('day')
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        areaChg(val){
            this.v_area = ''
            val.forEach(item=>{
                if(this.v_area==''){
                    this.v_area ='\''+item+'\''
                }else{
                    this.v_area =this.v_area+','+'\''+item+'\''
                }
            })           
            this.shopid =''
            this.shopArr=[]
            getBaseData(this.v_bsurl,'PARENTNO','22363','','','v_sys_base',' and subno in ('+this.v_area+')').then(res=>{
                this.shopArr =res.result
            })
        },
        //科目明细
        getSubList(cond){
            this.inData=[]  //收入
            this.exData=[]  //费用
            this.trData=[] //付款
            this.taxData=[] //税
            //获取所有产品记录且初始化分页记录    
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'parentno', p_value:'0',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_AMZ_SUBJECT' },
            }).then(res=>{ 
                if (res.code==='200'){
                    this.subData =res.result
                    this.subData.forEach(item=>{
                        if (item['IDNO'].substring(0,1)=='1'){
                            this.inData.push(item)
                        }else if (item['IDNO'].substring(0,1)=='2'){
                            this.exData.push(item)
                        }else if (item['IDNO'].substring(0,1)=='3'){
                            this.trData.push(item)
                        }else if (item['IDNO'].substring(0,1)=='4'){
                            this.taxData.push(item)
                        }
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
 
            }) 
        },
        //查询
        qryTabData(){
            let v_cond =''
            let v_shop =''
            if (this.shopid!==''){
                this.shopid.forEach(item=>{
                    if(v_shop==''){
                        v_shop ='\''+item+'\''
                    }else{
                        v_shop =v_shop+','+'\''+item+'\''
                    }
                })  
            }
            if (v_shop.length>0 ){
                v_cond =' and shopid in ('+v_shop+') and areano in ('+this.v_area+') and dttm>=\''+this.frdttm+'\' and dttm<=\''+this.todttm+'\''
            }else if (v_shop.length==0 && this.areano.length>0){
                v_cond =' and areano in ('+this.v_area+') and dttm>=\''+this.frdttm+'\' and dttm<=\''+this.todttm+'\''
            }else{
                v_cond =' and dttm>=\''+this.frdttm+'\' and dttm<=\''+this.todttm+'\''
            }

            this.loadWin =true
            this.tempData =[]
            this.exArr =[]
            this.transArr=[]
            this.taxArr=[]
            this.v_saleQty=0
            let t1001=0,t1002=0,t1003=0,t1004=0,t1005=0,t1008=0,t1009=0,t1012=0,t1013=0 ,t3001=0,t4001=0,t4003=0,t4002=0
            let t2002=0,t2003=0,t2004=0,t2005=0,t2006=0,t2007=0,t2008=0 ,t2012=0 ,t2014=0 ,t2015=0 ,t2016=0,t3004=0
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid, p_cond:v_cond,p_table:'V_AMZ_QUERY' },
            }).then(res=>{ 
                if (res.code=='200'){
                        this.qryData =res.result
                        this.qryData.forEach(item=>{
                            this.v_saleQty =Number(this.v_saleQty)+ Number(!item['QTY']?0:item['QTY'])
 
                            t1001 =parseFloat(t1001)+ parseFloat(item['T1001'])
                            t1002 =parseFloat(t1002)+ parseFloat(item['T1002'])
                            t1003 =parseFloat(t1003)+ parseFloat(item['T1003'])
                            t1004 =parseFloat(t1004)+ parseFloat(item['T1004'])
                            t1005 =parseFloat(t1005)+ parseFloat(item['T1005'])
                            t1008 =parseFloat(t1008)+ parseFloat(item['T1008'])
                            t1009 =parseFloat(t1009)+ parseFloat(item['T1009'])
                            t1012 =parseFloat(t1012)+ parseFloat(item['T1012'])
                            t1013 =parseFloat(t1013)+ parseFloat(item['T1013'])

                            t2002 =parseFloat(t2002)+ parseFloat(item['T2002'])
                            t2003 =parseFloat(t2003)+ parseFloat(item['T2003'])
                            t2004 =parseFloat(t2004)+ parseFloat(item['T2004'])
                            t2005 =parseFloat(t2005)+ parseFloat(item['T2005'])
                            t2006 =parseFloat(t2006)+ parseFloat(item['T2006'])
                            t2007 =parseFloat(t2007)+ parseFloat(item['T2007'])
                            t2008 =parseFloat(t2008)+ parseFloat(item['T2008'])
                            t2012 =parseFloat(t2012)+ parseFloat(item['T2012'])
                            t2014 =parseFloat(t2014)+ parseFloat(item['T2014'])
                            t2015 =parseFloat(t2015)+ parseFloat(item['T2015'])
                            t2016 =parseFloat(t2016)+ parseFloat(item['T2016'])

                            t3001 =parseFloat(t3001)+ parseFloat(item['T3001'])
                            t3004 =parseFloat(t3004)+ parseFloat(item['T3004'])
                            t4001 =parseFloat(t4001)+ parseFloat(item['T4001'])
                            t4002 =parseFloat(t4002)+ parseFloat(item['T4002'])
                            t4003 =parseFloat(t4003)+ parseFloat(item['T4003'])
                        })
                        //收入 1002,1004,1009,1011,1012,1014,1015
                        this.tempData.push({code:'1001',prc:t1001.toFixed(2),left:'N' })
                        this.tempData.push({code:'1002',prc:t1002.toFixed(2),left:'Y'})
                        this.tempData.push({code:'1003',prc:t1003.toFixed(2),left:'N' })
                        this.tempData.push({code:'1004',prc:t1004.toFixed(2) ,left:'Y'})
                        this.tempData.push({code:'1005',prc:t1005.toFixed(2),left:'N' })
                        this.tempData.push({code:'1006',prc:'0.00' ,left:'N'})
                        this.tempData.push({code:'1007',prc:'0.00',left:'N'})
                        this.tempData.push({code:'1008',prc:t1008.toFixed(2),left:'N' })
                        this.tempData.push({code:'1009',prc:t1009.toFixed(2) ,left:'Y'})
                        this.tempData.push({code:'1010',prc:'0.00',left:'N' })
                        this.tempData.push({code:'1011',prc:'0.00',left:'Y'})
                        this.tempData.push({code:'1012',prc:t1012.toFixed(2) ,left:'Y'})
                        this.tempData.push({code:'1013',prc:t1013.toFixed(2),left:'N' })
                        this.tempData.push({code:'1014',prc:'0.00' ,left:'Y'})
                        this.tempData.push({code:'1015',prc:'0.00',left:'Y'})
                        this.tempData.push({code:'1016',prc:'0.00',left:'N' })
                        this.tempData.push({code:'1017',prc:'0.00',left:'N'})
                        this.inSum = (t1001+t1002+t1003+t1004+t1005+t1008+t1009+t1012+t1013).toFixed(2)
                        this.v_inleft=( t1002 +t1004 +t1009+t1012 ).toFixed(2)
                        this.v_inright=(t1001 +t1003+ t1005+t1008 +t1013).toFixed(2)
                        //费用 2001,2002,2004,2006,2008,2009,2012,2013,2014,2015,2017
                        this.exArr.push({code:'2001',prc:'0.00',left:'Y' })
                        this.exArr.push({code:'2002',prc:t2002.toFixed(2),left:'Y' })
                        this.exArr.push({code:'2003',prc:t2003.toFixed(2),left:'N'})
                        this.exArr.push({code:'2004',prc:t2004.toFixed(2),left:'Y' })
                        this.exArr.push({code:'2005',prc:t2005.toFixed(2),left:'N' })
                        this.exArr.push({code:'2006',prc:t2006.toFixed(2),left:'Y' })
                        this.exArr.push({code:'2007',prc:t2007.toFixed(2),left:'N' })
                        this.exArr.push({code:'2008',prc:t2008.toFixed(2) ,left:'Y'})
                        this.exArr.push({code:'2009',prc:'0.00' ,left:'Y'})
                        this.exArr.push({code:'2010',prc:'0.00' ,left:'N'})
                        this.exArr.push({code:'2011',prc:'0.00',left:'N' })
                        this.exArr.push({code:'2012',prc:t2012.toFixed(2) ,left:'Y'})
                        this.exArr.push({code:'2013',prc:'0.00',left:'Y' })
                        this.exArr.push({code:'2014',prc:t2014.toFixed(2),left:'Y' })
                        this.exArr.push({code:'2015',prc:t2015.toFixed(2),left:'Y' })
                        this.exArr.push({code:'2016',prc:t2016.toFixed(2) ,left:'N'})
                        this.exArr.push({code:'2017',prc:'0.00',left:'Y' })
                        this.exSum = (t2002 +t2003+t2004+t2005+t2006+t2007+t2008+t2012+t2014+t2015+t2016).toFixed(2)
                        this.v_exleft = (t2002 +t2004+t2006+t2008+t2012+t2014+t2015).toFixed(2)
                        this.v_exright = (t2003+t2005+t2007+t2016).toFixed(2)
                        //转账
                        this.transArr.push({code:'3001',prc:t3001.toFixed(2) ,left:'Y'})
                        this.transArr.push({code:'3002',prc:'0.00' })
                        this.transArr.push({code:'3003',prc:'0.00' })
                        this.transArr.push({code:'3004',prc:t3004.toFixed(2) ,left:'N'})
                        this.tranSum =(t3001+t3004).toFixed(2)
                        this.v_trleft =t3001.toFixed(2)
                        this.v_trright =t3004.toFixed(2)
                        //税收
                        this.taxArr.push({code:'4001',prc:t4001.toFixed(2),left:'N' })
                        this.taxArr.push({code:'4002',prc:t4002.toFixed(2),left:'Y' })
                        this.taxArr.push({code:'4003',prc:t4003.toFixed(2),left:'Y' }) 
                        this.taxSum =(t4001+t4003+t4002).toFixed(2)
                        this.v_taxleft =(t4003+t4002).toFixed(2)
                        this.v_taxright =(t4001).toFixed(2)
                        //广告费
                        this.v_adFee = (t2016+t2015).toFixed(2)
                        //运费 FBA
                        this.v_shpFee = (t2002+t2003).toFixed(2)
                        this.loadWin =false
                }else{
                    this.loadWin =false
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
            // 国家、店铺退货数量   
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond:'select sum(to_number(qty)) qty,sum(to_number(AMT)) AMT from V_AMZ_RETURN where 1=1 '+v_cond },
            }).then(res=>{
                this.v_rtnQty =res.result[0]?res.result[0]['QTY']:0
                this.v_rtnAmt =res.result[0]?res.result[0]['AMT']:0
            })
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','22371','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .left{
        text-align:left;
        padding-left:6px;
        width:100%; 
    }
    .right{
        text-align:right;
        padding-right:6px;
        width:100%;
    }
    .headbar{
        padding-left:5px; 
        line-height:32px;
        background:#fff;
        overflow: auto;
        padding-top:2px;
        display:flex;
        border-bottom:2px solid #389;
        height:40px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 